export default __webpack_public_path__ + "static/media/wix-icon.566c3a2c.svg";